// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__21h24","bigColWidth":"Table_bigColWidth__1-VOG","biggerColWidth":"Table_biggerColWidth__1zf96","row":"Table_row__2QV_M","col":"Table_col__1-3oG"};